import React from 'react';
import { motion } from 'framer-motion';

const Logo = ({ className = "" }) => {
  return (
    <motion.div 
      className={`flex items-center gap-2 ${className}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="relative w-10 h-10">
        <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path 
            d="M20 2L35 11V29L20 38L5 29V11L20 2Z" 
            stroke="#004C97" 
            strokeWidth="2" 
            fill="none"
          />
          <path 
            d="M20 10L28 15V25L20 30L12 25V15L20 10Z" 
            fill="#004C97"
          />
          <path 
            d="M15 18L20 15L25 18V22L20 25L15 22V18Z" 
            fill="#D4EDF7"
          />
        </svg>
      </div>
      <div className="flex flex-col">
        <span className="text-xl font-bold text-[#004C97] leading-tight">Randovate</span>
        <span className="text-xs text-[#004C97] tracking-wider">LABS</span>
      </div>
    </motion.div>
  );
};

export default Logo;